import React, {useState, useEffect} from 'react';
import '../Options.css';



const Essay = ({ questionId, setAnswers, currentAnswer }) => {
    const [text, setText] = useState( '')

    useEffect(() => {
       setText(currentAnswer ? currentAnswer : '')
    }, [currentAnswer]);


    useEffect(() => {
        setAnswers(text)
    }, [text]);

  
    return (
     <div>
        {/* <div className='shortAnswer__subtitle'>Ваш ответ</div> */}
        <textarea type='text' maxLength={1000} id={questionId} value={text} onChange={(e) => setText(e.target.value)} className='essay__input'/>
     </div>

    )
}
export default Essay